// extracted by mini-css-extract-plugin
export default {"yearGraphCard":"NeighbourhoodYearSummary_yearGraphCard__MbIYt","monthGraphCard":"NeighbourhoodYearSummary_monthGraphCard__YsUd0"};